import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import GridElementContainer from '../../../GridElementContainer'
import TopTutor from './TopTutor'

import { selectRole } from '../../../../../../../routing/fetchingfunction/user/user.reducer'

import { TUTOR_ROLE } from '../../../../../../../constants'

const TopTutors = ({
  topTutors = [],
  title = 'Top Tutors',
  containerClassName = '',
  className = '',
}) => {
  const role = useSelector(selectRole)

  const isTutor = role === TUTOR_ROLE

  const topTutorsContent = topTutors.map((tutor) => {
    return <TopTutor key={tutor.id || tutor.tutor_name} tutor={tutor} />
  })

  return (
    <GridElementContainer className={`!rounded-0 ${containerClassName}`} title={title}>
      {topTutors.length ? (
        <div
          className={`grid gap-[5px] w-[calc(100%+5px)] pr-[5px] max-h-[207px] overflow-y-auto primary-scroll ${className}`}
        >
          {topTutorsContent}
        </div>
      ) : (
        <div className="w-full h-full flex items-center justify-center flex-col border-[#FFCA84] border-[1px] rounded-[6px] p-[10px]">
          <img
            src="/assets/icon/empty-tutors.svg"
            alt="Empty Tutors"
            className="w-[97px] h-[97px]"
          />

          <p className="text-sm leading-[29px] text-primary-100 font-bold mt-[10px] text-center">
            View Your Favourite Tutors After Taking A Few Classes
          </p>

          {!isTutor && (
            <Link
              to="/findtutor"
              className="h-[36px] px-[14px] flex items-center justify-center shadow-button bg-primary-button hover:bg-primary-button-hover transition-colors duration-200 ease rounded-[8px] text-sm leading-[20px] font-semibold text-white mt-[10px]"
            >
              Book Tutor
            </Link>
          )}
        </div>
      )}
    </GridElementContainer>
  )
}

export default TopTutors
